var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text-sm leading-6",class:[
    _vm.color,
    _vm.fontWeight,
    { 'md:text-3.5xl uppercase': _vm.size === 'h1' },
    { 'md:text-2.5xl uppercase': _vm.size === 'h2' }
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }